import { c as _c } from "react/compiler-runtime";
import { Skeleton } from '@systemeio/components';
import React from 'react';
import DeadlineSettingsItemLayout from './deadline-settings-item-layout';
const DeadlineSettingsTabSkeleton = () => {
  const $ = _c(3);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <DeadlineSettingsItemLayout><Skeleton className="h-5 w-20" /><Skeleton className="h-5 w-40" /><Skeleton className="h-16" /></DeadlineSettingsItemLayout>;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <DeadlineSettingsItemLayout><Skeleton className="h-5 w-60" /></DeadlineSettingsItemLayout>;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <>{t0}{t1}<DeadlineSettingsItemLayout><Skeleton className="h-4 w-20" /><Skeleton className="h-4 w-40" /><Skeleton className="h-5" /></DeadlineSettingsItemLayout></>;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  return t2;
};
export default DeadlineSettingsTabSkeleton;